module.exports = __webpack_public_path__ + "img/3-3.9b0f2706.png";